<template>
    <v-select v-bind="context.attrs" :data-type="context.type" :modelValue="selectedValue" @update:modelValue="handleInput" :class="selectClasses" :options="selectOptions" :reduce="reduceOption" :getOptionKey="getOptionKey" label="label" :placeholder="context.attrs?.placeholder || '- Selecteer -'" :appendToBody="true" :calculatePosition="calculateSelectPosition" @close="onClose" @option:selected="onOptionSelect">
        <template #selected-option-container="{ option }">
            <span class="vs__selected">
                <span class="option-label" v-html="formatOptionLabel(option)"></span>
            </span>
        </template>

        <template #option="slotProps">
            <span class="option-label" v-html="formatOptionLabel(slotProps)"></span>
        </template>

        <template #open-indicator="{ attributes }">
            <span v-bind="attributes" class="icon icon--bostonBlue icon--arrowDown"></span>
        </template>
    </v-select>
</template>

<script src="./FormulateAvSelect.js"></script>
